import { useState } from "react";
import { X, Plus } from "lucide-react";

export function CategorySelect({ options, value, onChange, testid = "category-select" }) {
  const [custom, setCustom] = useState("");
  const toggle = (name) =>
    onChange(value.includes(name) ? value.filter((v) => v !== name) : [...value, name]);
  const addCustom = () => {
    const c = custom.trim();
    if (c && !value.includes(c)) onChange([...value, c]);
    setCustom("");
  };

  return (
    <div data-testid={testid}>
      {value.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mb-3">
          {value.map((v) => (
            <span key={v} className="inline-flex items-center gap-1 bg-secondary text-cobalt text-xs rounded-full pl-3 pr-1.5 py-1">
              {v}
              <button type="button" onClick={() => toggle(v)} className="hover:text-destructive" data-testid={`cat-remove-${v}`}>
                <X size={12} />
              </button>
            </span>
          ))}
        </div>
      )}
      <div className="flex flex-wrap gap-1.5">
        {options.filter((o) => !value.includes(o)).map((o) => (
          <button key={o} type="button" onClick={() => toggle(o)} data-testid={`cat-option-${o}`}
            className="text-xs border border-border rounded-full px-3 py-1 text-muted-foreground hover:border-cobalt hover:text-cobalt transition-colors">
            {o}
          </button>
        ))}
      </div>
      <div className="flex items-center gap-2 mt-3">
        <input
          value={custom}
          onChange={(e) => setCustom(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), addCustom())}
          placeholder="Add a custom category…"
          data-testid="category-custom-input"
          className="flex-1 bg-transparent border border-border rounded-md px-3 py-2 text-sm outline-none focus:border-cobalt transition-colors"
        />
        <button type="button" onClick={addCustom} data-testid="category-custom-add"
          className="inline-flex items-center gap-1 border border-border rounded-md px-3 py-2 text-sm hover:bg-secondary/60 transition-colors">
          <Plus size={14} /> Add
        </button>
      </div>
    </div>
  );
}
